import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useLang } from '../context/LangContext';
import { API_URL, resolveImage } from '../config';

const API = API_URL;

const Hero = () => {
  const { t } = useLang();
  const [stats, setStats] = useState(null);

  useEffect(() => {
    axios.get(`${API}/products/stats/public`)
      .then(r => setStats(r.data.data))
      .catch(() => {});
  }, []);

  const heroImage = stats?.heroProduct?.image
    || 'https://images.unsplash.com/photo-1695048133142-1a20484d2569?w=300&h=600&fit=crop';
  const heroAlt = stats?.heroProduct?.name || 'Featured product';

  return (
    <section className="hero-r">
      {/* Background */}
      <div className="hero-r__bg">
        <div className="hero-r__bg-left" />
        <div className="hero-r__bg-right" />
        <div className="hero-r__noise" />
        <div className="hero-r__line hero-r__line--1" />
        <div className="hero-r__line hero-r__line--2" />
        <div className="hero-r__line hero-r__line--3" />
      </div>

      {/* Inner */}
      <div className="hero-r__inner">

        {/* LEFT — texte */}
        <div className="hero-r__content">

          <div className="hero-r__tag">
            <span className="hero-r__tag-dot" />
            <span>{t('hero_badge')}</span>
          </div>

          <h1 className="hero-r__title">
            <span className="hero-r__title-white">Matrix</span>
            <span className="hero-r__title-red">Electronic</span>
            <span className="hero-r__title-outline">Devices</span>
          </h1>

          <p className="hero-r__by">BY <strong>Maher</strong></p>

          <p className="hero-r__sub">{t('hero_subtitle')}</p>

          <div className="hero-r__cta">
            <a href="#products" className="hero-r__btn-primary">
              {t('hero_cta_buy')}
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                <path d="M5 12h14M12 5l7 7-7 7"/>
              </svg>
            </a>
            <a href="#products" className="hero-r__btn-ghost">{t('hero_cta_view')}</a>
          </div>

          <div className="hero-r__stats">
            <div className="hero-r__stat">
              <strong>{stats ? stats.total : '—'}</strong>
              <span>{t('hero_stat_products')}</span>
            </div>
            <div className="hero-r__sep" />
            <div className="hero-r__stat">
              <strong>{stats ? `${stats.totalStock}+` : '—'}</strong>
              <span>{t('hero_stat_clients')}</span>
            </div>
            <div className="hero-r__sep" />
            <div className="hero-r__stat">
              <strong>{stats ? `${stats.avgRating}★` : '—'}</strong>
              <span>{t('hero_stat_rating')}</span>
            </div>
          </div>
        </div>

        {/* RIGHT — image */}
        <div className="hero-r__visual">
          <div className="hero-r__card">
            <div className="hero-r__card-glow" />
            <div className="hero-r__card-stripe" />
            <img
              src={resolveImage(heroImage)}
              alt={heroAlt}
              className="hero-r__img"
            />
            <div className="hero-r__card-corner hero-r__card-corner--tl" />
            <div className="hero-r__card-corner hero-r__card-corner--br" />
          </div>

          <div className="hero-r__float hero-r__float--top">
            <span className="hero-r__float-icon">📦</span>
            <div>
              <strong>{t('hero_shipping_label')}</strong>
              <small>{t('hero_shipping_sub')}</small>
            </div>
          </div>

          <div className="hero-r__float hero-r__float--bottom">
            <span className="hero-r__float-icon">⚡</span>
            <div>
              <strong>{t('hero_flash_label')}</strong>
              <small>{t('hero_flash_sub')}</small>
            </div>
          </div>

          {/* Cercles décoratifs */}
          <div className="hero-r__ring hero-r__ring--1" />
          <div className="hero-r__ring hero-r__ring--2" />
        </div>
      </div>

      {/* Scroll */}
      <div className="hero-r__scroll">
        <div className="hero-r__scroll-bar" />
        <span>Scroll</span>
      </div>
    </section>
  );
};

export default Hero;
